module.exports = __webpack_public_path__ + "img/help-ct6.5565f66b.png";